import TagsList from "components/TagsList";
import FormField from "ds/components/Form/Field";
import useTypedContext from "hooks/useTypedContext";

import { ScanSettingsContextData } from "../Context";

const ScanSettingsResourceScopeView = () => {
  const { scanSettings } = useTypedContext(ScanSettingsContextData);

  const resourceTypes = scanSettings.scope.map(({ type }) => type);

  return (
    <FormField label="Resource types" noMargin>
      <TagsList tags={resourceTypes} alwaysExpanded withEmptyPlaceholder />
    </FormField>
  );
};

export default ScanSettingsResourceScopeView;
